import { ActionType, ProTable } from "@ant-design/pro-components";
import { Button, Select, message, Popconfirm, Modal, Form } from "antd";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import GlobalWrap from "../../components/globalWrap";
import FeedbackManagementForm from "./FeedbackManagementForm";
import { PlusOutlined } from "@ant-design/icons";

export default function FeedbackManagement() {
    const { jsonRequest } = useGlobalState();
    const tableRef = useRef<ActionType>();
    const [form] = Form.useForm();

    useEffect(() => {
        tableRef.current?.reload();
    }, []);

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "反馈分类",
            dataIndex: "category",
            align: "center",
            search: true,
            render: (text: string) => text === 'WHERE' ? "从哪儿知道" : text === 'DEMAND' ? "需求" : "-",
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder={'请选择反馈分类'}
                    options={[
                        { label: "从哪儿知道", value: 'WHERE' },
                        { label: "需求", value: 'DEMAND' },
                    ]}
                />
            ),
        },
        {
            title: "名称",
            dataIndex: "name",
            align: "center",
            search: false,
        },
        {
            title: "排序",
            dataIndex: "sortNum",
            align: "center",
            search: false,
        },
        {
            title: "反馈状态",
            dataIndex: "status",
            align: "center",
            search: true,
            renderFormItem: () => (
                <Select
                    allowClear
                    placeholder='请选择状态'
                    options={[
                        { label: "启用", value: 'ENABLE' },
                        { label: "禁用", value: 'DISABLE' },
                    ]}
                />
            ),
            render: (text: string) => {
                switch (text) {
                    case "ENABLE":
                        return <span style={{ color: 'green' }}>启用</span>;
                    case "DISABLE":
                        return <span style={{ color: 'red' }}>禁用</span>;
                    default:
                        return <span>未知</span>;
                }
            }
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => <>
                <Button type="link" onClick={() => handleAddOrEdit(record)}>编辑</Button>
                <Popconfirm
                    title={`确定${record.status === 'ENABLE' ? "禁用" : "启用"}吗？`}
                    onConfirm={() => updateStatus(record)}
                    okText="是"
                    cancelText="否"
                >
                    <Button type="link">
                        {record.status === 'ENABLE' ? "禁用" : "启用"}
                    </Button>
                </Popconfirm>
            </>,
        }
    ];

    const handleAddOrEdit = (item: any) => {
        Modal.confirm({
            width: 500,
            title: !!item.id ? `反馈编辑 - ${item.name}` : "反馈新增",
            content: <GlobalWrap><FeedbackManagementForm form={form} item={item} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                if (!!item?.id) {
                    await jsonRequest.put("/back/sys-feedback-pop-up/modify", {
                        ...values,
                        id: item.id,
                    }).then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("编辑成功");
                            } else {
                                message.error(data?.msg || "编辑失败");
                            }
                        }
                        )
                } else {
                    await jsonRequest.post("/back/sys-feedback-pop-up/add", {
                        ...values,
                    }).then((resp: any) => resp.json())
                        .then((data: any) => {
                            if (data?.code === 0) {
                                message.success("新增成功");
                            } else {
                                message.error(data?.msg || "新增失败");
                            }
                        }
                        )
                }
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const updateStatus = async (record: any) => {
        await jsonRequest.put(`/back/sys-feedback-pop-up/change-status/${record.id}`, {},
        ).then((resp: any) => resp.json())
            .then((data: any) => {
                if (data?.code === 0) {
                    message.success(`${record.status === 'ENABLE' ? "禁用" : "启用"}成功`);
                } else {
                    message.error(data?.msg || "编辑失败");
                }
                tableRef.current?.reload();
            })
    }

    const request = async (params: any) => {
        const result: any = await jsonRequest.get("/back/sys-feedback-pop-up/page", {
            currentPage: params.current,
            pageSize: params.pageSize,
            status: params.status,
            category: params.category,
        }).then((resp: any) => resp.json());
        const { data } = result;
        return { data: data?.data, success: result.code === 0, total: data.count };
    };

    return <>
        <h1>反馈管理</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={{ defaultPageSize: 10, showSizeChanger: true }}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [<Button
                key="button"
                icon={<PlusOutlined />}
                onClick={() => handleAddOrEdit({})}
                type="primary"
            >
                新增
            </Button>]}
        />
    </>;
}